import React from 'react';
import { useAuth } from 'hooks/useAuth';

// Головний компонент сторінки "Welcome"
const WelcomePage = () => {
  // Отримуємо дані про поточного авторизованого користувача з хука useAuth
  const { user } = useAuth();

  return (
    <section id="welcome-page">
      <div className="background-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="center-content">
        <h1>
          Вітаю, <span className="gradient-name">{user?.username || 'друже'}</span>!
        </h1>
      </div>

    </section>
  );
};

export default WelcomePage;